import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import EditorialRubricheHero from "./sections/EditorialRubricheHero";
import FeaturedRubriche from "./sections/FeaturedRubriche";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <EditorialRubricheHero />
      <FeaturedRubriche />
      <Footer />
    </div>;
}